import { Trans, useTranslation } from 'next-i18next';
import cn from 'classnames';

import styles from './WhySellAtCatawiki.module.scss';
import { BuyerBlock } from './components/BuyerBlock';
import { ExpertBlock } from './components/ExpertBlock';
import { PaymentBlock } from './components/PaymentBlock';
import { WHY_SELL_AT_CATAWIKI_ID } from '../../constants';
import { StrongBrandContainer } from '../../components/StrongBrandContainer';

export const WhySellAtCatawiki = () => {
  const { t } = useTranslation();
  return (
    <section
      className="why-sell-with-catawiki u-m-t-xxl-18 u-m-t-sm-m"
      id={WHY_SELL_AT_CATAWIKI_ID}
    >
      <h2 className="u-typography-h2">
        <Trans
          i18nKey="seller_register.why.title"
          components={{
            strong: <StrongBrandContainer className="u-typography-h2-serif" />,
          }}
        />
      </h2>

      <h3 className="u-typography-h3 u-m-t-xl u-color-secondary u-m-t-l">
        {t('seller_register.why.subtitle')}
      </h3>
      <div className={cn(styles.keyPoints, 'tw:flex tw:justify-between')}>
        <BuyerBlock />
        <ExpertBlock />
        <PaymentBlock />
      </div>
    </section>
  );
};
